import "./sentry.js";
import "./bootstrap";
import "./devsquad-sidecar";

import jsQR from "jsqr";
window.jsQR = jsQR;

import "./data";
import "./directives";
